import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import AppModal from "../../Common/AppModal";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { updateSingleCustomerExternalIDsSuccess } from "../../../store/customers/action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  // Task 24678 - the landing-page picker on this wizard reads
  // MenuNavOption (master), which is the table AuthLoginController
  // resolves Staff.DefaultOpeningNavMenu against. It used to read
  // MenuNavItem (per company), whose ids mean something else entirely.
  getAvailableMenuNavigationItems,
  getMenuNavigationList,
  getSingleNavigationMenu,
} from "../../../store/navigationMenu/action";
import { getSecurityAuthRoleList } from "../../../store/security/action";
import {
  getLicensesSubscriptionProductList,
  getSubscriptionProductList,
} from "../../../store/manageLicense/action";
import {
  createCompanyToUser,
  createCompanyToUserSuccess,
  getCompanyToUserListTeam,
  getUserAvailableDashboard,
  updateCompanyToUserTeam,
  updateCompanyToUserTeamSuccess,
} from "../../../store/companyToUser/action";
import classnames from "classnames";
import TabUserDetails from "./tabUserDetails";
import TabDefaultOptions from "./tabDefaultOptions";
import TabStaffDetails from "./tabStaffDetails";
import TabSubscriptionPlans from "./tabSubscriptionPlans";
import TabSummary from "./tabSummary";
// Change #100163 (revised) - the working schedule as a step of its own.
import TabWorkingSchedule from "./tabWorkingSchedule";
// Change #100462
import { useSubscriptionBilling, isEnterpriseBilling } from "./EnterpriseSeats";

// The wizard, in order. Task 24455 added Staff Details; before that a new
// user arrived with no job title and no phone number.
const STAFF_STEP_ID = 2;

const WIZARD_STEPS = [
  { id: 1, label: "User Details" },
  { id: 2, label: "Staff Details" },
  { id: 3, label: "Default Options" },
  // Was "Subscription Plan's".
  { id: 4, label: "Subscription Plans" },
  { id: 5, label: "Summary" },
  // Change #100163 (revised) - after Summary, because the schedule belongs to
  // the Staff record the Summary's Create makes. Locked until then.
  { id: 6, label: "Working Schedule" },
];
const SUMMARY_STEP_ID = 5;
const SCHEDULE_STEP_ID = 6;

const CreateEditCompanyUserLicenses = ({
  isEdit,
  modal,
  setModal,
  toggle,
  updateData,
}) => {
  const dispatch = useDispatch();
  //initial values
  const InitialData = {
    User_Email: "",
    User_UserFirstName: "",
    User_UserLastName: "",
    User_ImageUrl: "",
    DashboardTemplate_Id: "",
    MenuNav_Id: "",
    DefaultOpeningNavMenu: "",
    MasterPaymentCard_Id: "",
    // Task 24455 - staff-level (company-local) details, all optional.
    Staff_JobTitle: "",
    Staff_ContactTelephoneNumber: "",
    Staff_ContactMobileNumber: "",
    Staff_ContactEmailAddress: "",
    FlagEmailToUser: "1",
    EmailSelfMode: "CC",
    EmailExtraMode: "CC",
    securityauthrole_list: [
      // {
      //   Id: 1,
      // },
    ],
    subscriptionproduct_list: [
      // {
      //   Id: 201,
      // },
    ],
    AmountLocalSubTotal: "",
    AmountLocalVat: "",
    AmountLocalTotal: "",
  };

  useEffect(() => {
    // Nav Menu List
    dispatch(getMenuNavigationList());

    //Nav Menu Items List
    dispatch(getAvailableMenuNavigationItems());

    //Security Roles List
    dispatch(getSecurityAuthRoleList());

    //Dashboard Template List
    dispatch(getUserAvailableDashboard());

    //Subscription Product List
    dispatch(getSubscriptionProductList());
  }, []);

  const [createUpdateData, setCreateUpdateData] = useState(InitialData);
  // Change #100462 - Enterprise companies see "Your Plan", not plans to buy.
  const subscriptionBilling = useSubscriptionBilling();
  const { getLicensesSubscriptionProductListAPI } = useSelector((state) => ({
    getLicensesSubscriptionProductListAPI:
      state.ManageLicense.subscriptionProductList?.subscriptionproduct_list,
  }));
  console.log("createUpdateData", createUpdateData);
  //isEdit
  useEffect(() => {
    if (isEmpty(updateData)) return;
    if (!isEdit) return;
    setCreateUpdateData(updateData);
  }, [updateData, isEdit]);

  useEffect(() => {
    if (createUpdateData?.subscriptionproduct_list?.length > 0) {
      let AmountLocalSubTotal = 0;
      let AmountLocalVat = 0;
      let AmountLocalTotal = 0;

      createUpdateData?.subscriptionproduct_list?.map((item) => {
        const findItem = getLicensesSubscriptionProductListAPI?.find(
          (x) => x.Id === item.Id
        );
        if (findItem) {
          AmountLocalSubTotal += +findItem?.ProrataAmountLocalSubTotal;
          AmountLocalVat += +findItem?.ProrataAmountLocalVat;
          AmountLocalTotal += +findItem?.ProrataAmountLocalTotal;
        }
      });

      setCreateUpdateData({
        ...createUpdateData,
        AmountLocalSubTotal: AmountLocalSubTotal?.toFixed(2),
        AmountLocalVat: AmountLocalVat?.toFixed(2),
        AmountLocalTotal: AmountLocalTotal?.toFixed(2),
      });
    } else {
      setCreateUpdateData({
        ...createUpdateData,
        AmountLocalSubTotal: 0,
        AmountLocalVat: 0,
        AmountLocalTotal: 0,
      });
    }
  }, [createUpdateData?.subscriptionproduct_list]);
  console.log("createUpdateData", createUpdateData);

  useEffect(() => {
    if (isEmpty(createUpdateData?.DashboardTemplate_Id)) return;
    dispatch(
      getSingleNavigationMenu({ id: createUpdateData?.DashboardTemplate_Id })
    );
  }, [createUpdateData?.DashboardTemplate_Id]);

  const { CreateSUCCESS, UpdateSUCCESS } = useSelector((state) => ({
    CreateSUCCESS: state.CompanyToUser?.createCompanyToUserSuccess,
    UpdateSUCCESS: state.CompanyToUser?.updateCompanyToUserTeamSuccess,
  }));

  //create
  useEffect(() => {
    if (isEmpty(CreateSUCCESS)) return;
    if (CreateSUCCESS?.status === 200) {
      toast.success(CreateSUCCESS?.message);

      dispatch(getCompanyToUserListTeam());
      setModal(false);
    } else {
      toast.error(CreateSUCCESS?.message);
    }
    dispatch(createCompanyToUserSuccess([]));
  }, [CreateSUCCESS]);

  const [activeVerticalTab, setActiveVerticalTab] = useState(1);

  //
  // MenuNav_Id: "",
  //     DefaultOpeningNavMenu: "",
  //     securityauthrole_list
  useEffect(() => {
    // check all steps are coretly filled before moving to next step
    switch (true) {
      // case 1: check if name last name and email is filled if not then an error toast should be shown that step 1 needs to be filled
      case activeVerticalTab > 1 &&
        (!createUpdateData?.User_UserFirstName ||
          !createUpdateData?.User_UserLastName ||
          !createUpdateData?.User_Email):
        toast.error("Please fill the User Details");
        setActiveVerticalTab(1);
        break;
      // Step 2 (Staff Details) has no guard on purpose - every field on it is
      // optional and none of it should stand between you and an account.
      case activeVerticalTab > 3 &&
        (!createUpdateData?.DashboardTemplate_Id ||
          !createUpdateData?.MenuNav_Id ||
          isEmpty(createUpdateData?.securityauthrole_list)):
        toast.error("Please fill the Default Options");
        setActiveVerticalTab(3);
        break;
      // Change #100473 - an Enterprise company picks no plan: "Your Plan" only
      // shows the seats, and the backend puts the company's plan on the new
      // user itself (SubscriptionLicenceController). Demanding a pick here
      // bounced every Enterprise user back to step 4.
      case activeVerticalTab > 4 &&
        !isEnterpriseBilling(subscriptionBilling) &&
        isEmpty(createUpdateData?.subscriptionproduct_list):
        toast.error("Please choose a subscription plan");
        setActiveVerticalTab(4);
        break;

      default:
        break;
    }
  }, [activeVerticalTab]);

  // Task 24454 - "Create Another User (Same Settings)" keeps the options,
  // licences and roles, so steps 3-5 are already answered. Clicking Next three
  // times just to reach the create button is busywork; this jumps straight to
  // the Summary. It stops there rather than creating outright, so the licence
  // charge and the card choice stay a deliberate click.
  const canJumpToSummary =
    !isEdit &&
    !!createUpdateData?.DashboardTemplate_Id &&
    !!createUpdateData?.MenuNav_Id &&
    !isEmpty(createUpdateData?.securityauthrole_list) &&
    (isEnterpriseBilling(subscriptionBilling) ||
      !isEmpty(createUpdateData?.subscriptionproduct_list));

  // Change #100163 - Summary is no longer the last step, so name it.
  const jumpToSummary = () => setActiveVerticalTab(SUMMARY_STEP_ID);

  // Change #100163 (revised) - the user the Summary just created, so the
  // Working Schedule step knows whose schedule it is. Cleared by "Create
  // Another User".
  const [createdUser, setCreatedUser] = useState(null);
  const scheduleUnlocked = !!createdUser?.Staff_Id;

  // Editing a user does not write the Staff record, so that step is hidden -
  // and skipped over in whichever direction you are travelling, rather than
  // leaving a dead rung on the ladder.
  // Editing an existing user has no schedule step either: that lives on the
  // person's staff profile.
  const visibleSteps = isEdit
    ? WIZARD_STEPS.filter(
        (step) => step.id !== STAFF_STEP_ID && step.id !== SCHEDULE_STEP_ID
      )
    : WIZARD_STEPS;

  const previousTabRef = useRef(1);
  useEffect(() => {
    if (isEdit && activeVerticalTab === STAFF_STEP_ID) {
      const goingForward = previousTabRef.current < STAFF_STEP_ID;
      setActiveVerticalTab(goingForward ? STAFF_STEP_ID + 1 : STAFF_STEP_ID - 1);
      return;
    }
    previousTabRef.current = activeVerticalTab;
  }, [activeVerticalTab, isEdit]);

  return (
    <>
      <AppModal
        open={modal}
        onClose={toggle}
        title={isEdit ? "Edit User" : "Create New User"}
        icon={<PersonAddAltOutlinedIcon />}
        headerAccent="indigo"
        size="lg"
        hideFooter
      >
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody className="form-steps">
                  <form className="vertical-navs-step">
                    <Row className="gy-5">
                      <Col lg={3}>
                        <Nav className="flex-column custom-nav nav-pills">
                          {visibleSteps.map((step) => {
                            const isActive = activeVerticalTab === step.id;
                            const isDone = activeVerticalTab > step.id;
                            const isLocked =
                              step.id === SCHEDULE_STEP_ID && !scheduleUnlocked;
                            return (
                              <NavItem key={step.id}>
                                <NavLink
                                  href="#"
                                  className={classnames({
                                    active: isActive,
                                    done: isDone,
                                  })}
                                  style={isLocked ? { opacity: 0.55 } : undefined}
                                  title={
                                    isLocked
                                      ? "Available once the user has been created"
                                      : undefined
                                  }
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (isLocked) {
                                      toast.info(
                                        "Create the user on the Summary step first - then set their working schedule."
                                      );
                                      return;
                                    }
                                    setActiveVerticalTab(step.id);
                                  }}
                                >
                                  <span className="step-title me-2">
                                    {/* Every step used to show the same red
                                        cross, done or not, which read as
                                        "everything is wrong". */}
                                    <i
                                      className={classnames(
                                        "step-icon me-2",
                                        isLocked
                                          ? "ri-lock-line text-muted"
                                          : isDone
                                          ? "ri-checkbox-circle-fill text-success"
                                          : isActive
                                          ? "ri-record-circle-fill"
                                          : "ri-circle-line text-muted"
                                      )}
                                    ></i>
                                    Step {step.id}
                                  </span>
                                  {step.id === 4 && isEnterpriseBilling(subscriptionBilling)
                                    ? "Your Plan"
                                    : step.label}
                                </NavLink>
                              </NavItem>
                            );
                          })}
                        </Nav>
                      </Col>
                      <Col lg={9}>
                        <div className="px-lg-4">
                          <TabContent activeTab={activeVerticalTab}>
                            <TabPane tabId={1}>
                              <TabUserDetails
                                createUpdateData={createUpdateData}
                                setCreateUpdateData={setCreateUpdateData}
                                activeVerticalTab={activeVerticalTab}
                                setActiveVerticalTab={setActiveVerticalTab}
                                isEdit={isEdit}
                                onJumpToSummary={jumpToSummary}
                                canJumpToSummary={canJumpToSummary}
                              />
                            </TabPane>
                            <TabPane tabId={2}>
                              <TabStaffDetails
                                createUpdateData={createUpdateData}
                                setCreateUpdateData={setCreateUpdateData}
                                activeVerticalTab={activeVerticalTab}
                                setActiveVerticalTab={setActiveVerticalTab}
                              />
                            </TabPane>
                            <TabPane tabId={3}>
                              <TabDefaultOptions
                                createUpdateData={createUpdateData}
                                setCreateUpdateData={setCreateUpdateData}
                                activeVerticalTab={activeVerticalTab}
                                setActiveVerticalTab={setActiveVerticalTab}
                                isEdit={isEdit}
                              />
                            </TabPane>
                            <TabPane tabId={4}>
                              <TabSubscriptionPlans
                                createUpdateData={createUpdateData}
                                setCreateUpdateData={setCreateUpdateData}
                                activeVerticalTab={activeVerticalTab}
                                setActiveVerticalTab={setActiveVerticalTab}
                              />
                            </TabPane>
                            <TabPane tabId={5}>
                              <TabSummary
                                setModal={setModal}
                                createUpdateData={createUpdateData}
                                setCreateUpdateData={setCreateUpdateData}
                                activeVerticalTab={activeVerticalTab}
                                setActiveVerticalTab={setActiveVerticalTab}
                                isEdit={isEdit}
                                onUserCreated={setCreatedUser}
                              />
                            </TabPane>
                            {!isEdit && (
                              <TabPane tabId={SCHEDULE_STEP_ID}>
                                <TabWorkingSchedule
                                  createdUser={createdUser}
                                  setActiveVerticalTab={setActiveVerticalTab}
                                  setModal={setModal}
                                />
                              </TabPane>
                            )}
                          </TabContent>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </AppModal>
    </>
  );
};

export default CreateEditCompanyUserLicenses;
